export type CurrencyAssetType = 'calendar' | 'property' | 'otherservices' | 'other';

type CurrencyType = 'USD' | 'EUR' | 'GBP' | 'JPY' | 'GEL';

type CurrenciesList = {
    calendarCurrency?: string;
    financePropertyCurrency?: string;
    financeServicesCurrency?: string;
    financeOtherCurrency?: string;
};

const currencySymbol = (currency?: string) => {
    switch (currency) {
        case 'USD':
            return '$';
        case 'EUR':
            return '€';
        case 'GBP':
            return '£';
        case 'JPY':
            return '¥';
        case 'GEL':
            return '₾';
        default:
            return '₾';
    }
};

const syncCurrency = (asset?: CurrencyAssetType, multicurrency?: boolean, currentCurrency?: CurrencyType | CurrenciesList) => {
    if (!multicurrency && typeof currentCurrency === 'object') {
        switch (asset) {
            case 'calendar':
                return currencySymbol(currentCurrency.calendarCurrency);
            case 'property':
                return currencySymbol(currentCurrency.financePropertyCurrency);
            case 'otherservices':
                return currencySymbol(currentCurrency.financeServicesCurrency);
            case 'other':
                return currencySymbol(currentCurrency.financeOtherCurrency);
            default: 
                return currencySymbol();
        }
    };

    return currencySymbol(typeof currentCurrency === 'string' ? currentCurrency : undefined);
}

export const CurrencyHelper = {
    currencySymbol,
    syncCurrency
};
